/* eslint-disable eqeqeq */
import React, { useState, useLayoutEffect, useEffect } from "react";

/** Components */
import { Button, TablePagination, Paper, TextField, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, TableFooter, Collapse, ButtonGroup, Dialog, Tooltip } from "@mui/material";
import { FilterBy } from "../../commons/filter.component";
import { M23Detail } from "./m23Detail";
import LoadingProgress from "../../commons/LoadingProgress.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";

/** Api & Function */
import { getM23, getPO } from "./../../../services/api";
import { convertQueryStringToObject, updateNode } from "../../../services/libService";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";

/** Hook */
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { statusColor } from "../../config";
import { useParamFilter } from "../../commons/customHook";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export default function M23() {
  const [t] = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const [isSearchOpen, setSearchOpen] = useState(true);
  const user = useSelector((state) => state.user.data);
  // custom hook
  const location = useLocation();
  const { ticketid } = useParams();
  const { fetchData, data, setData, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 50, organization_id: user?.organization_id }, getM23);
  const filter = convertQueryStringToObject(location.search);

  const [input, setInput] = useState({
    selectedCustomer: null,
    billnumber: filter.code || null,
    fkey: filter.fkey || null,
    billdate: filter.start_date || null,
    end_date: filter.end_date || null,
  });

  const handleRowClick = (e, id) => {
    history.push(`/m23/${id}${location.search}`);
  };
  const handleUpdate = (res, newItem) => {
    if (res.code === 200) {
      setData((prev) => updateNode(prev, (data) => data.map((item) => (item.id == newItem.id ? newItem : item))));
    }
  };
  const handleDelete = (id) => {
    setData((prev) => prev.map((item) => (item.id == id ? { ...item, status: "DELETED" } : item)));
  };
  const handleSearch = () => {
    fetchData((prev) => ({ ...input, po_id: input.po?.id, po: null }));
  };
  // effect
  useLayoutEffect(() => {
    fetchData(convertQueryStringToObject(location.search));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN NHẬP MUA HÀNG NỘI ĐỊA XE XITEC"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Tooltip title="Tạo mới">
            <Button variant="outlined" color="primary" onClick={() => history.push("/m23/create")}>
              <AddIcon />
            </Button>
          </Tooltip>
          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      <div>
        <Collapse in={isSearchOpen}>
          <TextField
            label={t("Số hóa đơn nhập mua")}
            value={input.billnumber || ""}
            onChange={(e) => setInput((prev) => ({ ...prev, billnumber: e.target.value || null }))}
            style={{ margin: "5px" }}
            InputProps={{ style: { minWidth: "200px" } }}
          />
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            label={t("Đơn mua hàng quốc nội")}
            getDataFunc={() => getPO({ status: 1 })}
            value={input.po}
            getOptionLabel={(option) => `${option.trx_number} (${option.product_name}) -- ${option.route}` || ""}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, po: newValue }))}
          />
          <CustomDatePicker label={t("Ngày nhập mua")} value={input.billdate} onChange={(value) => setInput((prev) => ({ ...prev, billdate: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
          <Button variant="outlined" onClick={handleSearch} style={{ margin: "10px 0" }}>
            {t("Tìm kiếm")}
          </Button>
        </Collapse>
        <div style={{ display: "flex" }}>
          {loading ? (
            <LoadingProgress />
          ) : (
            <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
              <Table stickyHeader>
                <TableHead style={{ backgroundColor: "#f0f3f5" }}>
                  <TableRow>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      STT
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Mã")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      ERP Code
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Số hóa đơn nhập mua")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Ngày hóa đơn nhập mua")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Bill/BBL")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("L15")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("KG")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Trạng thái")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length ? (
                    data.map((item, index) => (
                      <TableRow hover style={{ cursor: "pointer", backgroundColor: ticketid === item.id ? "lightgray" : "" }} key={index} onClick={(e) => handleRowClick(e, item.id)}>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.id}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.fkey}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.erp_code}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.billNumber}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.bill_date && moment(item.bill_date).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.billQty?.toLocaleString(undefined, { minimumFractionDigits: 3 })}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.billL15?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.billKG?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          <div className={`status ${item.status}`} style={{ color: statusColor[item.status] }}>
                            {t(item.status)}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={20}>
                        {t(isAllow ? "Không có dữ liệu" : "No permission")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}
        </div>
        <Detail id={ticketid} onClose={() => history.push(`/m23${location.search}`)} onUpdate={handleUpdate} onDelete={handleDelete} />
      </div>
    </div>
  );
}

const Detail = ({ id, onClose, onUpdate, onDelete }) => {
  return (
    <Dialog open={Boolean(id)} onClose={onClose} maxWidth={false} fullWidth>
      <div align="center" style={{ padding: 10, height: "100vh" }}>
        <M23Detail id={id} onClose={onClose} onSaveResponse={onUpdate} onUpdate={onUpdate} onDelete={onDelete} />
      </div>
    </Dialog>
  );
};
